




































 
import {Vue} from '../../constants/constants'
import { staticContent } from "../../localisation/detect-lang"


export default  Vue.component('feed-back-confirmation', {
     data() {
    return {
            staticContent
    };
  },
 computed:{
   bindConditionalClasses(){
     return this.$root.bindConditionalClasses;
    },

 },
  methods:{
    handleClose(){
      this.$root.modalToggler('feed-back-confirmation','hide')
    }
  }
})
